import { useEffect } from 'react';
import { KeyboardEventPredicate } from '@/utils/keyboard';

export const useKeydown = (
  key: string | KeyboardEventPredicate,
  callback: (event: KeyboardEvent) => void,
  options?: boolean | AddEventListenerOptions
) => {
  useEffect(() => {
    function handleKeydown(event: KeyboardEvent) {
      if (typeof key === 'string' && event.key === key) {
        callback(event);
      } else if (typeof key === 'function' && key(event)) {
        callback(event);
      }
    }

    window.addEventListener('keydown', handleKeydown, options);

    return () => {
      window.removeEventListener('keydown', handleKeydown, options);
    };
  }, [key, callback]);
};
